export default __webpack_public_path__ + "static/media/POWER.d83b4663.png";